import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators} from "@angular/forms";


@Component({
  selector: "app-trainning",
  templateUrl: "./trainning.component.html",
  styleUrls:["./trainning.component.scss"],
})
export class TrainningComponent implements OnInit, OnChanges {
  @Input() formTabData: any; // Input property to receive formData from the parent component
  dateFormat = "dd/MM/yyyy";
  currentDate: Date;
  conferenceFormGroup: FormGroup[] = [];
  trainingFormGroup: FormGroup[] = [];
  // Define your options for multiple-selection fields
  noiDungKyThuatOptions: string[] = [
    "Quản lý đất và bề mặt đất",
    "Quản lý nước",
    "Quản lý gió",
    "Quản lý bóng che",
    "Kỹ thuật tỉa cành",
    "Quản lý dinh dưỡng",
    "Quản lý động vật",
    "Sâu bệnh hại",
  ];
  doiTuongQuanLyOptions: string[] = [
    "Gặm nhấm",
    "Bọ xít muỗi",
    "Sâu đục trái",
    "Sâu đục thân",
    "Rệp sáp",
    "Bệnh thối trái",
    "Bệnh Vệt sọc đen",
    "Sâu bệnh hại khác",
  ];
  noiDungKhacOptions: string[] = [
    "An toàn lao động",
    "Luật lao động",
    "Bảo vệ môi trường",
  ];
  taiLieuDaNhanOptions: string[] = [
    "Manual Kỹ thuật canh tác ca cao bền vững",
    "Các dòng ca cao phổ biến",
    "Kỹ thuật trồng và chăm sóc cây ca cao",
    "Kỹ thuật tỉa cành cây ca cao",
    "Độ pH đất và bón vôi",
    "Cải thiện sức khỏe đất",
    "Phòng trừ bệnh thối trái",
    "Phòng trừ bọ xít muỗi",
    "Thiếu hụt dinh dưỡng ở cây ca cao",
    "Quản lý dịch hại tổng hợp trên cây ca cao",
  ];
  hinhThucOptions: string[] = [
    "Đánh giá vườn",
    "Trả kết quả",
    "Hướng dẫn kỹ thuật",
    "Khác",
  ];
  taDanhGiaKhaNangHopTacOptions: string[] = [
    "Sẵn sàng hợp tác",
    "Muốn nhưng không sắp xếp thời gian được",
    "Từ chối hợp tác",
  ];
  nongDanDanhGiaChatLuongOptions: string[] = [
    "Hữu ích",
    "Bình thường",
    "Cần chứng minh thực tế",
    "Không hữu ích",
  ];

  constructor(private fb: FormBuilder) {
    // Initialize with one form in each group
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formTabData && this.formTabData) {
      if (Object.keys(this.formTabData).length === 0) {
        this.conferenceFormGroup = [];
        this.trainingFormGroup = [];
        this.addConferenceForm();
        this.addTrainingForm();
      }

      try {
        if (this.formTabData.daoTao) {
          const trimmedJsonString = this.formTabData.daoTao.trim();
        const trainingData = JSON.parse(trimmedJsonString);

        if (trainingData) {
          if (Array.isArray(trainingData.conferenceForm)) {
            this.conferenceFormGroup = trainingData.conferenceForm.map((item) => {
              const formGroup = this.createConferenceForm();
              this.setFormValues(formGroup, item);
              return formGroup;
            });
          }
          if (Array.isArray(trainingData.trainingForm)) {
            this.trainingFormGroup = trainingData.trainingForm.map((item) => {
              const formGroup = this.createTrainingForm();
              this.setFormValues(formGroup, item);
              return formGroup;
            });
          }
        }
      }} catch (error) {
        console.error("Error parsing JSON data:", error);
        // Handle the error or provide appropriate fallback behavior
      }
    }
  }
  private setFormValues(formGroup: FormGroup, data: any): void {
    for (const controlName in data) {
      if (data.hasOwnProperty(controlName)) {
        const control = formGroup.get(controlName);
        if (control) {
          control.setValue(data[controlName]);
        }
      }
    }
  }

  // Methods to add new forms
  addConferenceForm(): void {
    const newForm = this.createConferenceForm();
    this.conferenceFormGroup.push(newForm);
  }

  addTrainingForm(): void {
    const newForm = this.createTrainingForm();
    this.trainingFormGroup.push(newForm);
  }

  // Methods to remove forms
  removeConferenceForm(index: number): void {
    if (index >= 0 && index < this.conferenceFormGroup.length) {
      this.conferenceFormGroup.splice(index, 1);
    }
  }

  removeTrainingForm(index: number): void {
    if (index >= 0 && index < this.trainingFormGroup.length) {
      this.trainingFormGroup.splice(index, 1);
    }
  }

  // Helper methods to create new form groups
  private createConferenceForm(): FormGroup {
    return this.fb.group({
      ngayThamDuHoiThao: [null],
      soGioDaoTao: [null],
      noiDungKyThuat: [[]],
      doiTuongQuanLy: [[]],
      noiDungKhac: [[]],
      taiLieuDaNhan: [[]],
    });
  }

  private createTrainingForm(): FormGroup {
    return this.fb.group({
      ngayDaoTao: [this.currentDate, Validators.required],
      soGioDaoTao: [null],
      hinhThuc: [null, Validators.required],
      customHinhThuc: [null],
      diemDanhGiaHienTrangVuon: [null],
      noiDungKyThuat: [null],
      doiTuongQuanLy: [null],
      taiLieuDaNhan: [null],
      taDanhGiaKhaNangHopTac: [null, Validators.required],
      nongDanDanhGiaChatLuong: [null],
    });
  }

  ngOnInit(): void {
    // You can perform any additional initialization here.
    this.addConferenceForm();
    this.addTrainingForm();
    this.currentDate = new Date();
    for (let index = 0; index < this.trainingFormGroup.length; index++) {
      const hinhThucControl = this.trainingFormGroup[index].get("hinhThuc");

      hinhThucControl.valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.trainingFormGroup[index].get("customHinhThuc").setValue(null);
        }
      });
    }
  }

  private serializeFormGroup(formGroup: FormGroup): any {
    const serialized = {};
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        serialized[controlName] = formGroup.get(controlName).value;
      }
    }
    return serialized;
  }

  submitForm() {
    const formData = {
      conferenceForm: this.conferenceFormGroup.map((formGroup) =>
        this.serializeFormGroup(formGroup)
      ),
      trainingForm: this.trainingFormGroup.map((FormGroup) =>
        this.serializeFormGroup(FormGroup)
      ),
    };

    return formData;
  }

  getValidationStatus(controlName: string, yourForm: FormGroup): string {
    const control = yourForm.get(controlName);
    return  control.invalid ? 'error' : '';
  }
}
